var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"connected-layout"},[_c('nav-bar',{class:{ active: _vm.menuVisible }}),_c('side-bar',{class:{ active: _vm.menuVisible }}),_c('div',{staticClass:"container",on:{"click":_vm.closeMenu}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }